<template>
    <div id="ingredients" class="tab-pane active">
        <p class="help-block">
            <label>
                <input type="checkbox" value="0" v-model="selectedDatabase" checked="checked" />
                <span class="db1">Livsmedelsverkets (Makro- och mikronutrienter)</span>
            </label>
            <label>
                <input type="checkbox" class="db2" value="1" v-model="selectedDatabase" checked="checked" />
                <span class="db2">Livsmedelsföretagens (Makro- och delvis mikronutrienter)</span>
            </label>
        </p>
        <table>
            <thead>
                <tr>
                    <th class="ingredient-col">Ingrediens</th>
                    <th class="quantity-col">Mängd</th>
                    <th class="unit-col">Enhet</th>
                    <th class="add-col"></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="ingredient-col">
                        <div class="form-group">
                            <span v-if="loading" class="loading-icon"></span>
                            <input
                                type="search"
                                id="select-ingredient"
                                class="form-control"
                                placeholder="Sök efter ingrediens"
                                @keyup="initIngredientSearch()"
                                v-model="query"
                                autocomplete="off"
                            />
                            <ul class="select-ingredient">
                                <li
                                    v-for="(ingredient, index) in searchResults"
                                    @click="getSelectedIngredient(ingredient)"
                                    track-by="$index"
                                    v-bind:class="[ingredient.DABAS == 0 ? 'db1' : 'db2']"
                                >
                                    {{ ingredient.LivsmedelNamn }}
                                </li>
                            </ul>
                        </div>
                    </td>
                    <td class="quantity-col">
                        <div class="form-group">
                            <input
                                id="select-quantity"
                                type="number"
                                class="form-control quantity"
                                min="0"
                                step="0.5"
                                v-model="qty"
                            />
                        </div>
                    </td>
                    <td class="unit-col" v-bind:class="[units.length == 0 ? 'unit-disable' : '']">
                        <div class="form-group">
                            <select id="select-unit" class="unit form-control" v-model="selectedUnitIndex">
                                <option v-for="(unit, index) in units" :value="index">
                                    {{ unit.Enhet }} {{ unit.BearbetadForm }}
                                </option>
                            </select>
                        </div>
                    </td>
                    <td class="add-ingredient-col actions">
                        <div class="form-group">
                            <svg id="add-ingredient" class="icon add-ingredient" @click="addIngredient">
                                <use xlink:href="#icon-plus"></use>
                            </svg>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import axios from "axios";
import state from "./../state.js";
import _ from "lodash";

export default {
	data() {
		return {
			state,
			qty: 1,
			query: "",
			db: "",
			loading: false,
			selectedDatabase: [],
			selectedUnitIndex: 0,
			selectedIngredientId: undefined,
			selectedIngredient: "",
			searchResults: [],
			units: [],
		};
	},

	methods: {
		initIngredientSearch() {
			this.searchResults = [];
			this.loading = true;
			this.throttledMethod();
		},

		getIngredients() {
			const db = this.selectedDatabase.length == 1 ? this.selectedDatabase[0] : "";

			if (this.query.length > 1) {
				axios.get("/recept/api/ingredients/" + this.query + "/" + db).then((response) => {
					this.searchResults = response.data;
					this.loading = false;

					if (response.data.length == 0) {
						this.units = [];
					}
				});
			} else {
				this.loading = false;
				this.searchResults = [];
			}
		},

		throttledMethod: _.debounce(function () {
			this.getIngredients();
		}, 2000),

		getSelectedIngredient(ingredient) {
			this.selectedIngredient = ingredient.LivsmedelNamn;
			this.selectedIngredientId = ingredient.LivsmedelID;
			this.query = ingredient.LivsmedelNamn;
			this.units = ingredient.ingredient_unit || [];
			this.units.push({ Enhet: "gram", EnhetID: 0 });
			this.units.sort(function (a, b) {
				return a.Enhet > b.Enhet ? 1 : b.Enhet > a.Enhet ? -1 : 0;
			});

			var moveEnhetToFront = function (arr, value) {
				var position = false;
				for (var i = 0; i < arr.length; i++) {
					if (arr[i].Enhet == value) position = i;
				}
				if (position) {
					arr.splice(0, 0, arr.splice(position, 1)[0]);
				}
			};
			moveEnhetToFront(this.units, "gram");
			moveEnhetToFront(this.units, "dl");
			moveEnhetToFront(this.units, "st");

			this.db = ingredient.DABAS;

			this.searchResults = [];
		},

		addIngredient() {
			if (this.selectedIngredient != "") {
				this.state.prompt = false;

				const addIngredient = {
					quantity: this.qty,
					unit_id: this.units[this.selectedUnitIndex].EnhetID,
					unit: this.units[this.selectedUnitIndex].Enhet,
					unitProcessedForm: this.units[this.selectedUnitIndex].BearbetadForm
						? this.units[this.selectedUnitIndex].BearbetadForm
						: "",
					ingredient: this.selectedIngredient,
					ingredient_id: this.selectedIngredientId,
					db: this.db,
				};

				if (this.selectedIngredientId) {
					this.state.recipeIngredients.push(addIngredient);
					this.selectedUnitIndex = 0;
					this.selectedIngredientId = undefined;
					this.selectedIngredient = "";
					this.query = "";
					this.qty = 1;
					this.units = [];
				}
			} else {
				this.state.prompt = "Välj ingrediens";
			}
		},
	},
};
</script>
